import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TabViewCategory } from '@ddt-web/config';
import { TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import * as set from 'lodash/set';

@Component({
	selector: 'risk-decomposition-table',
	templateUrl: './decomposition-table.component.html'
})
export class DecompositionTableComponent implements OnChanges {

	@Input() public activeOnlyTab: TabData;
	@Input() public totalPortfolioTab: TabData;
	@Input() public decompositionTabs: Array<TabData>;
	@Input() public contributionTabs?: Array<TabData>;
	@Input() public tabId: string;
	@Input() public striped: boolean = false;

	public showTotalPortfolioTab: boolean = false;
	public showActiveOnlyTab: boolean = false;

	public parentCollapsed: Array<boolean> = [];
	public contributionTabsMapping: { [tabId: string]: TabData } = {};
	public customClasses: string = '';

	constructor(private contentService: ContentService) { }

	public ngOnChanges(): void {
		const totalPortfolioCells = get(this.totalPortfolioTab, 'cells', []);
		this.showTotalPortfolioTab = totalPortfolioCells.some(row => row.some(cell => cell.formattedValue !== '-')) && totalPortfolioCells.length;
		const activeOnlyCells = get(this.activeOnlyTab, 'cells', []);
		this.showActiveOnlyTab = activeOnlyCells.some(row => row.some(cell => cell.formattedValue !== '-')) && activeOnlyCells.length;
		if (!isEmpty(this.contributionTabs)) {
			this.contributionTabs.forEach((tab, index) => {
				this.contributionTabsMapping[get(tab, 'config.id', index.toString())] = tab;
			});
		}

		this.customClasses = 'toggle-buttons';
		// TODO swchopra: to be removed once CJ feature is live on 360 and update configs instead
		if (!isEmpty(this.decompositionTabs)) {
			this.decompositionTabs.forEach(tabData => {
				if (get(tabData, 'config.id').includes('total.risk')) {
					set(tabData, 'config.title.label', this.contentService.get('PORTFOLIO_TAB', TabViewCategory.PORTFOLIO_TAB));
				}
				if (get(tabData, 'config.id').includes('active.risk')) {
					set(tabData, 'config.title.label', this.contentService.get('BENCHMARK_TAB', TabViewCategory.BENCHMARK_TAB));
				}
			});
		}
	}
}
